import React, { useEffect, useState } from "react";
import { View, StyleSheet, ScrollView } from "react-native";

import * as SecureStore from "../DeviceAsyncStorage";

import { translate } from "../../locales/translate";
import Loading from "../../components_v2/Spinner";

import Theme from "../../argon-ui/Theme";

import { ArButton } from "../../argon-ui";
import ServerInfo from "../../viewModels/ServerInfo";
import Text from "../TextFont";
import ServerItem from "./ServerItem";
import { HStack, VStack } from "native-base";
import {
  faCheck,
  faPlus,
  faServer,
  faExclamationTriangle,
} from "../../../assets/consts/faCharCodes";
import ServerIP from "./ServerIP";
import { getServerInfo } from "../../util";
import MessageBox from "../MessageBox";
import FontAwesomeIcon from "../FontAwesomeIcon";
import BuildingInfo from "../../viewModels/BuildingInfo";

const axios = require("axios").default;

type Props = {
  onSelect: (serverInfo: ServerInfo, serverAddress: string) => void;
  onCancel?: () => void;
  onBack?: () => void;
};

export interface ServerItemProps {
  isActive: boolean;
  serverId: string;
  address: string | null;
  localAddress: string | null;
  buildingName: string | null;
}

const ServerList = (props: Props) => {
  const { onSelect, onCancel, onBack } = props;
  const [serverList, setServerList] = useState<ServerItemProps[] | []>([]);

  // === isServerSelected = serverId ===
  const [isServerSelected, setIsServerSelected] = useState<string | null>(null);
  const [showServerIP, setShowServerIP] = useState<boolean>(false);

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const [loadingBtn, setLoadingBtn] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    getServers();
  }, []);
  const getServers = async () => {
    const servers = await SecureStore.Servers.getServers();
    const buildings = await SecureStore.Buildings.getBuildings();
    if (servers) {
      var serversModel: ServerItemProps[] = [];
      // === check isActive server ===
      var activeServerUrl = await SecureStore.getServerUrl();
      if (activeServerUrl?.endsWith("/")) {
        activeServerUrl = activeServerUrl.slice(0, -1);
      }
      let serverInfo = await SecureStore.Servers.getCurrentServer();
      servers?.forEach((server: ServerInfo) => {
        const findBuilding = buildings?.find(
          (building: BuildingInfo) => building.serverId === server.serverId
        );
        const serverModel: ServerItemProps = {
          isActive: server.serverId === serverInfo?.serverId,
          serverId: server.serverId,
          address: server?.publicAddress,
          buildingName: findBuilding && findBuilding.buildingName,
          localAddress: server?.localAddress,
        };
        serversModel.push(serverModel);
      });
      if (serversModel.length !== 0) {
        // === sort List by active server ===
        serversModel = serversModel.sort(function (
          a: ServerItemProps,
          b: ServerItemProps
        ) {
          if (a.isActive < b.isActive) return 1;
          if (a.isActive > b.isActive) return -1;
          // a must be equal to b
          return 0;
        });
        setServerList(serversModel);
      }
      setIsLoading(false);
    }
  };
  const onDeleteServerItemHandler = (serverId: string) => {
    if (serverId) {
      SecureStore.Servers.removeServer(serverId).catch((e) =>
        console.log("error remove server in serverList", e)
      );
      const filterServerLost = serverList.filter(
        (server: ServerItemProps) => server.serverId !== serverId
      );
      setServerList(filterServerLost);
    }
  };
  const onConnectHandler = async () => {
    setLoadingBtn(true);
    // === Server List from SecureStore ===
    const servers = await SecureStore.Servers.getServers();
    const findServer: ServerInfo | null | undefined = servers.find(
      (server: ServerInfo) => server.serverId === isServerSelected
    );
    if (findServer && (findServer.publicAddress || findServer.localAddress)) {
      var httpClient = axios.create();
      httpClient.defaults.timeout = 5000;
      const _getServerInfo = await getServerInfo(
        httpClient,
        findServer.publicAddress || findServer.localAddress
      );
      if (_getServerInfo) {
        onSelect &&
          onSelect(
            findServer,
            findServer.publicAddress || findServer.localAddress || ""
          );
      } else {
        setError(translate("serverList.errors.ServerError"));
        setTimeout(() => {
          setError("");
        }, 3000);
      }
    }
    setLoadingBtn(false);
  };
  const onConfirmServerHandler = async (
    serverInfo: ServerInfo,
    serverAddress: string
  ) => {
    const servers = await SecureStore.Servers.getServers();
    const someServerInfo = servers.some(
      (server: ServerInfo) => server.serverId === serverInfo.serverId
    );
    if (!someServerInfo) {
      SecureStore.Servers.addServer(serverInfo).catch((e) =>
        console.log("error add server in serverList", e)
      );
    }
    onSelect(serverInfo, serverAddress);
    onCancel && onCancel();
  };
  const renderEmptyButton = () => {
    return (
      <View style={{ padding: 5 }}>
        <ArButton
          style={{ flex: 1, marginBottom: 0 }}
          color="primary"
          icon={faPlus}
          iconColor={Theme.COLORS.WHITE}
          onPress={() => {
            setShowServerIP(true);
          }}
        >
          {translate("serverList.addServer")}
        </ArButton>
      </View>
    );
  };
  //   === Loading ===
  if (isLoading)
    return (
      <View style={{ flex: 1, minHeight: 200 }}>
        <Loading />
      </View>
    );
  // === Render Server IP ====
  if (showServerIP)
    return (
      <View style={{ padding: 10, flex: 1 }}>
        <ServerIP
          onCancel={() => setShowServerIP(false)}
          onConfirmServer={(serverInfo: ServerInfo, serverAddress: string) =>
            onConfirmServerHandler(serverInfo, serverAddress)
          }
        />
      </View>
    );

  //   === Empty list ===
  if (serverList.length === 0)
    return (
      <View
        style={{ flex: 1, justifyContent: "center", paddingHorizontal: 10 }}
      >
        <MessageBox icon={faServer} renderButton={renderEmptyButton()}>
          {translate("serverList.emptyListServer")}
        </MessageBox>
      </View>
    );
  return (
    <View style={{ padding: 10, flex: 1 }}>
      <ScrollView
        contentContainerStyle={{
          width: "100%",
        }}
      >
        {serverList.map((serverItem: ServerItemProps, i: number) => {
          return (
            <ServerItem
              key={i}
              content={serverItem}
              isSelected={isServerSelected === serverItem.serverId}
              onSelectedServerItem={(serverId: string) => {
                setIsServerSelected(serverId);
              }}
              onDeleteServerItem={(serverId: string) =>
                onDeleteServerItemHandler(serverId)
              }
            />
          );
        })}
      </ScrollView>
      {error && (
        <View
          style={{
            padding: 18,
            backgroundColor: Theme.COLORS.ERROR + 20,
            borderRadius: 10,
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            color={Theme.COLORS.ERROR}
            size={15}
          />
          <Text
            style={{
              color: Theme.COLORS.ERROR,
              fontSize: 14,
              marginHorizontal: 8,
            }}
          >
            {translate("app.serverError")}
          </Text>
        </View>
      )}
      <VStack space={2}>
        {/* === Submit Handler === */}
        <HStack space={2} mt="2.5">
          {/* === Connect to server === */}
          <ArButton
            style={[
              { flex: 1, marginBottom: 0 },
              !isServerSelected && { backgroundColor: Theme.COLORS.MUTED },
            ]}
            isLoading={loadingBtn}
            color="primary"
            disabled={Boolean(!isServerSelected)}
            icon={faCheck}
            iconColor={Theme.COLORS.WHITE}
            onPress={() => onConnectHandler()}
          >
            {translate("serverList.connect")}
          </ArButton>
          {/* === Add Server btn === */}
          <ArButton
            style={{ flex: 1, marginBottom: 0 }}
            color="primary"
            icon={faPlus}
            iconColor={Theme.COLORS.PRIMARY}
            variant="outline"
            onPress={() => {
              setShowServerIP(true);
            }}
          >
            {translate("serverList.addServer")}
          </ArButton>
        </HStack>
        {typeof onBack === "function" && (
          <ArButton
            color="muted"
            onPress={onBack}
            style={{ width: "100%", marginBottom: 0 }}
          >
            {translate("app.goBack")}
          </ArButton>
        )}
      </VStack>
    </View>
  );
};

export default ServerList;

const styles = StyleSheet.create({
  btn: {
    width: 45,
    height: 45,
    borderRadius: 10,
    alignSelf: "center",
    alignItems: "center",
    justifyContent: "center",
  },
  btnSubmit: {
    backgroundColor: Theme.COLORS.PRIMARY,
  },
  btnAdd: {
    backgroundColor: Theme.COLORS.PRIMARY + 99,
  },
});
